import Cookies from 'js-cookie';
import jwt from 'jsonwebtoken';
import { decodeBase64 } from './base64';
import Config from 'Config';
import AppStorage from 'AppStorage';
import { ApplicationPolicyPayload } from 'Constants';

// const privateKey = `-----BEGIN RSA PRIVATE KEY-----
// MIIEogIBAAKCAQEAzUj9y9szPESyMCm0s/aCsB4XzaZs27+l5JY0/w2UcIy+0rWZ
// aBJ/IweeyFx9kF3QLZztnSZBibZnOum6gXVxOvUAMoGvnl1odVNGYf2UV9fNEDuP
// 4kbve/SUbE3TxTS19PPzbu/k42WH0lem62Dw2klaiuweCkhHoKbS+ZvNqULP5CAy
// Nc4bX9Cvi13zZyrwKswbCwQhHbXCBA/J1rT+hQusjjCoxj4DpktBQCG6gMCurVL9
// Td8vaHDrp/vl4LyKxsudUadlJKZIEINZVJB5AN7mTaRD1hvV6aaxyIej/XEqzstP
// Fnya9xHpHcu1DBdaAX8anM/vsjTpNaP9hHqj3wIDAQABAoIBADw/ac0Efhr4BlvA
// Qbp3ZI+PpWjDqTstGeDmfJNGRwRpKi/pACbdFtcPC3i+PFO8VLauUcZHTgC+ubk+
// k3AfKaYl9XLdQM93loqocAWeSIUnXpWfBXFhZDO66jyG8tnzyFslpZIvcbuTNrNy
// 6hg2kTlfQeV3urFF2U+65jw/j7JW1I0NHfv61zPTLn8tFMuTIvbaWjUQOnI5df6W
// M+2td4GMpjhYwZLmu/RIT5NeVg9tXnRW6AD7dc51kIgzBaBgK/yhDm44mnqjNR9F
// ZugIfWpQbJ7tpJVfvZ/uvvRCYbkhd0D3uzidZuMH39t9B8pkH4n1VrOhBAQoDdFb
// TJIHkvECgYEA9dLZy15RKx/E1alEEtvYYxJ6chQ8F7faMyTpuez5Mib/+MqzbvHn
// PId6nt3OO2qGOxmwjHAzB5qEkceEWsxiEW4h2Agwvlu6ggyF68Cwt4M0ftu2gY4A
// WykDYjzU3kftQoLg50kYYqPbXFGj3yY1JyLw3gyQYMlRn8avUZIgOy0CgYEA1ciH
// O61I/PBXofNoze2uujcZqj/fcRn+RFzsXuvfBt0ScKR9tMNTMwyM6ob7f/fqkV4q
// FuS1CTFopq1j2N6qHWRPArU0oDF8lkD344lJmjdkaK2bMQ8BD0RmUEcU/6O+hLvW
// cDWgET3oRtmPXlSs2qayN6cQofr2KRJpUcTHUrsCgYBaRP1ZYt8nmNjtJOUsj7Kc
// XvK75ZZTl133Hfz+G3k+43dn4veVLBuf7JgosobC5tE37q0YRTNX/XPlHIEL3rW8
// dNbUv902afTJQNQEyJOcMAAc/Y29cWnMD/mAH5qDraIApJL2G69quYUaF5i3nw4x
// uvD8eVyjTgo9Q/apW6GeWQKBgDWiW5szPE6JFdNBuBeB/AYn8L5vy+UaOlp4Xazq
// zEdyiz/LZOZG4sa57VihiNNwJV9XGoQn2Ot3g+PdOGGea1t4YQIy6AMQp0si/Y4O
// UXLpVr2UYI0MUJ298VVOoAwKzq+KWKBKM+BfgbjUuE1YPQ2WKLwho+Cfj8Z6IgYr
// sj4lAoGAAkvruwOV0kPU/CB1G+UB6NRZ+YT+QnWGH0p0BmtLReZuYp6SsOEM4R3f
// gL/zSjQtWCnu/VkH9h/9SGNk0/lJDPLbncDMBeAtAsbqVWHABxgRJay8iR5CuB7R
// Uv6WHTukYOfNy9aQqFAfRobTIbCXiZj+0zrFfdBBD2pMrQw9dQM=
// -----END RSA PRIVATE KEY-----`;

// const publicKey = `-----BEGIN PUBLIC KEY-----
// MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA071/r/9ICCmmiWvVFDh5
// Ii1mUBH4niV0/Gjqbvri0kemtdh8AhFeevdH3dqcKq32v+AV0ny1+0x3dXh2MLXK
// 8GAy9D/Bw6eRLDI4vPW4GDx6qAKx4vsMo711xHFqHlAyDNXry95l5T/OKPG3hiEC
// oK4OEH54yvp/WirGk7Xm9SASIAS1BK5XD51hWEcWmOf2kU4ca5X+0qE3pCe2th5n
// bCSws1LbuAAeqKRSPeFUsFc3tKQHLPb6mBTZoR+QLH1qUvedmYhChwbp++5IxEMS
// ovODFlI/ZwuHZ3ga+gCVkqv1BURAjtuLGVbnnud3Ml3W27urW0Ew4BsewufSt6rg
// KQIDAQAB
// -----END PUBLIC KEY-----`;

// const dummyPublicKey = `-----BEGIN PUBLIC KEY-----
// MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2cUOb9iXQDUPc08/qgkQ
// HACZkxPVrRtq+GzXUeUzN30eH1CQSUoIfjU0ocnc4+q+A43FPO0Q1hCT47hzwucC
// 7hc96XDfMQUmXAidyhgWPACPSTKCqCYkdwcrWDsrK2Rb04Pi9nlZbW3m/uQat5/v
// V7DJXWT2g7I6tlU65cNTi0RodfPrjKcKhLQfJhk9RoMcCYmV9z246UsMKLPQWYrs
// SWoHN7NIt8W7xnFurlt6/MC1OIgEDvQRXNCM4S8v1WBy6LrZb7yMOFxp3huaiE/F
// qY8rh9FY0wYVyaooQKxHJib7UAAUFgI/g0qEpLJvUaNBVylykuXwffPKMdqQQ0Hc
// uwIDAQAB
// -----END PUBLIC KEY-----`;

// const dummyPayload = `eyJraWQiOiJTSUQwMDAyNDAiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJTSUQwMDAyNDAiLCJqdGkiOiIzZTFlZTY0My1hMDc0LTQ3NWEtODY1ZS1kMmEyZDdlMzkwMzMiLCJpYXQiOjE2MzIyMDg1ODcsImV4cCI6MTYzMjIxMDM4NywidGltZXN0YW1wIjoiMjAyMS0wOS0yMVQxNToxNjoyNyswODAwIiwidXNlcm5hbWUiOiIxNzM1NDUyNSIsImVwZldpdGhkcmF3YWxSZWZJRCI6IjYwMDAwMDAwMDA4NTM4NSIsImxhbmd1YWdlQ29kZSI6ImVuIiwicHJvZHVjdCI6eyJjb2RlIjoiZXBmY2kiLCJiYXNlZFR5cGUiOiJVIiwicGxhbkNvZGUiOm51bGwsInByZW1pdW1BbW91bnQiOjc1LjQsInN1bUFzc3VyZWRBbW91bnQiOjIwMDAwLCJtYXhXaXRoZHJhd2FsQW1vdW50IjoxMDI0NTYuNDQsInVuaXRQbGFuIjp7ImJlbmVmaXQiOlt7ImNvZGUiOiJlcGZjaSIsInVuaXRQcmljZSI6MzcuNywic2VsZWN0ZWRVbml0Q291bnQiOjIsImNvdmVyYWdlQW1vdW50UGVyVW5pdCI6MTAwMDAuMDAsInRvdGFsUHJpY2UiOjc1LjQsInRvdGFsQ292ZXJhZ2VBbW91bnQiOjIwMDAwfV19fSwiY3VzdG9tZXIiOnsicm9sZSI6IkEiLCJuYW1lIjoiTE9PIEtFTkcgV1VOIEAgTElNIEtFTkcgV1VOIiwiaWR0eXBlIjoiSU4iLCJpZG5vIjoiODIwMjAzMDQ3NzI5IiwiZG9iIjoiMTk4Mi0wMi0wMyIsImlzTWFsYXlzaWFuIjp0cnVlLCJzbW9rZXIiOmZhbHNlLCJnZW5kZXIiOiJNIiwiYWNjbm8iOiIxNzM1NDUyNSIsInJlbGlnaW9uIjoiTiIsIm1vYmlsZU5vIjoiMDEyMzI5NzUyNSIsImVtYWlsIjoiVEVTVEVNQUlMMTA3MjFAZ21haWwuY29tIiwiYWRkcmVzcyI6IjUtMi00IEpBTEFOIDkvMzIiLCJhZGRyZXNzMSI6IkJBTkRBUiBTVU5XQVkiLCJhZGRyZXNzMiI6IiIsImFkZHJlc3MzIjoiUEVUQUxJTkcgSkFZQSIsImFkZHJlc3M0IjoiU0VMQU5HT1IiLCJwb3N0Y29kZSI6IjQ2MTUwIiwiY2l0eSI6IlBFVEFMSU5HIEpBWUEiLCJzdGF0ZSI6IjEwIn0sImNoYW5uZWwiOiJNQlIifQ.zkKRImCLR0cnN3MM6xVCTkDcIw7Vld1vtdkwOmO9-YPzomdhNJvjnu3KbmncITfJzaRz2Lea8B6gloowaN9-M97fcXis4auRc8SuOwPk-dnDP9KzeBSigNFAxAxmjpMAKgHuHUwm0eXOpPsQ8zrLFQBsY2_GIIobr9kuIQQ3OiuzuytWJR6clIsw3GNfF9-kpkQJO7sWw6GS3h44CV9EbVrRpAhJAq-dforCfpiD4KKMWkQ0eezflGhLbUq4dSHr68B1ZEGTTUWRU3OqqEzbD2RFLwZt0bPrdSf_vVTwLAx27MazjIS5utB_GxNxHIBmrLwZgPEXE8dkp22ZXGDEzw`;

// const samplePayloadUat = `eyJraWQiOiJTSUQwMDAyNDAiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJTSUQwMDAyNDAiLCJqdGkiOiJhMDNhNTc3YS1iZmMzLTQxOTItOGIyOS00ZjEwMmM3MTkzOGQiLCJpYXQiOjE2MzE3MjA0ODAsImV4cCI6MTYzMTcyMjI4MCwidGltZXN0YW1wIjoiMjAyMS0wOS0xNVQyMzo0MToyMCswODAwIiwidXNlcm5hbWUiOiI3MTQ2NTE0NyIsImVwZldpdGhkcmF3YWxSZWZJRCI6IjYwMDAwMDAwMDA2NTgxNyIsImxhbmd1YWdlQ29kZSI6ImVuIiwicHJvZHVjdCI6eyJjb2RlIjoiZXBmY2kiLCJiYXNlZFR5cGUiOiJVIiwicGxhbkNvZGUiOm51bGwsInByZW1pdW1BbW91bnQiOjM3Ny4yLCJzdW1Bc3N1cmVkQW1vdW50Ijo0MDAwMCwibWF4V2l0aGRyYXdhbEFtb3VudCI6MTc3OTgxLjk1LCJ1bml0UGxhbiI6eyJiZW5lZml0IjpbeyJjb2RlIjoiZXBmY2kiLCJ1bml0UHJpY2UiOjk0LjMsInNlbGVjdGVkVW5pdENvdW50Ijo0LCJjb3ZlcmFnZUFtb3VudFBlclVuaXQiOjEwMDAwLjAwLCJ0b3RhbFByaWNlIjozNzcuMiwidG90YWxDb3ZlcmFnZUFtb3VudCI6NDAwMDB9XX19LCJjdXN0b21lciI6eyJyb2xlIjoiQSIsIm5hbWUiOiJMSU0gTE9LRSBCT09OIiwiaWR0eXBlIjoiSU4iLCJpZG5vIjoiNzYwNTAyMTMxNzIwIiwiZG9iIjoiMTk3Ni0wNS0wMiIsImlzTWFsYXlzaWFuIjp0cnVlLCJzbW9rZXIiOmZhbHNlLCJnZW5kZXIiOiJGIiwiYWNjbm8iOiI3MTQ2NTE0NyIsInJlbGlnaW9uIjoiTiIsIm1vYmlsZU5vIjoiMDExNjUwMjIwNzkiLCJlbWFpbCI6IlRFU1RFTUFJTDgxODhAZ21haWwuY29tIiwiYWRkcmVzcyI6Ik5PIDEzMTEgS0FNUFVORyBBU1RPTiIsImFkZHJlc3MxIjoiSkFMQU4gQkFEQUsgTUFUSSIsImFkZHJlc3MyIjoiTk8gMjYgSkFMQU4gU1MyLzcyIiwiYWRkcmVzczMiOiIiLCJhZGRyZXNzNCI6IiIsInBvc3Rjb2RlIjoiNDczMDAiLCJjaXR5IjoiUEVUQUxJTkcgSkFZQSIsInN0YXRlIjoiMTAifSwiY2hhbm5lbCI6Ik1CUiJ9.SzM0VEDdcxcIBY2ki8SRS6DAeunRVsoQX5g7RLJjP5vPpk1KvB9VCY3wgJzX_pkPQmipaNSOVWWTtp516cCP4O-VW84JlfmE6szy4qlNHEi5wuEw7eiBBABItqI2FDxlaC8GIWl3p461N3VDPN1NtpyXrpCVA_fWTkXVftEdTmiQrzflmtI93FVgavA7WtX3yl6HzAtsV0iW1LG1mkjN5G0FB7WIHnG6AvvTuZ_3yGEd_iARsThkkrIT9OwMWGvcttBSUhHANJnTYG-vgpTVLwlPcqWNd2RfFKb2EbvyhCbmFBeOW4NkLPA4eRXv9ObxK3d8WWrkRN9DXueCYuX9QQ`;

export const getEPFPayloadnew = (payloadToken) => {
  if (!payloadToken) {
    console.error('EPF jwt not found');
    return null;
  }

  let payload;
  try {
    payload = jwt.verify(payloadToken, Config.jwtPublicKey, {
      algorithm: 'RS256'
    });
  } catch (e) {
    // console.log('USING DUMMY PAYLOAD');
    console.log(e);
    try {
      console.log('getting payload by base64 decode');
      const mainPayload = payloadToken.split('.')[1];
      payload = JSON.parse(decodeBase64(mainPayload));
    } catch (err) {
      console.log(err);
      payload = '';
    }
  }
  return payload;
};

export const getEPFPayload = () => {
  let payloadToken = Cookies.get('epfPayloadJwt');
  if (!payloadToken) {
    console.error('EPF jwt not found');
    return null;
  }

  let payload;
  try {
    payload = jwt.verify(payloadToken, Config.jwtPublicKey, {
      algorithm: 'RS256'
    });
  } catch (e) {
    // console.log('USING DUMMY PAYLOAD');
    console.log(e);
    try {
      console.log('getting payload by base64 decode');
      const mainPayload = payloadToken.split('.')[1];
      payload = JSON.parse(decodeBase64(mainPayload));
    } catch (err) {
      console.log(err);
      payload = '';
    }
  }
  return payload;
};

const getBenefitObject = (product) => {
  return Array.isArray(product.unitPlan.benefit)
    ? product.unitPlan.benefit[0]
    : product.unitPlan.benefit;
};

export const mapPayload = (payload) => {
  // const result = { ...payload };
  console.log('payload#####:', payload);
  payload.policyNo = Cookies.get('epfReferenceNo');
  const product = Array.isArray(payload.product) ? payload.product : [payload.product];

  let result = {
    jti: payload.jti,
    iat: payload.exp - 1800,
    exp: payload.exp,
    timestamp: new Date().toTimeString(),
    sub: payload.sub,
    username: payload.username,
    languageCode: payload.languageCode,
    epfWithdrawalRefID: payload.epfWithdrawalRefID,
    itoOrderRefID: payload.policyNo,
    purchaseStatus: payload.purchaseStatus,
    purchasestatusCode: payload.purchaseStatusCode,
    purchaseOn: null,
    claimUpdatedDateTime: null,
    normineesUpdatedDateTime: null,
    channel: 'MBR',
    product: product.map((productItem) => {
      return {
        amount: payload.premiumAmount,
        policyNo: payload.policyNo,
        code: null,
        basedType: 'U',
        planCode: productItem.code,
        policyStatus: '',
        issueDateTime: null,
        termDateTime: null,
        effectiveDateTime: null,
        lineOfBusiness: 'CRIT',
        category: '',
        coverageAmount: productItem.sumAssuredAmount,
        paymentMethod: 'EPF',
        paymentFrequency: 'A',
        unitPlan: {
          benefit: [
            {
              ...getBenefitObject(productItem),
              riderStatus: ''
            }
          ]
        }
      };
    }),
    customer: {
      role: payload.customer.role,
      name: payload.customer.name,
      idno: payload.customer.idno,
      idtype: payload.customer.idtype,
      mobileNo: payload.customer.mobileNo,
      email: payload.customer.email,
      address: payload.customer.address,
      address1: payload.customer.address1,
      address2: payload.customer.address2,
      address3: payload.customer.address3,
      address4: payload.customer.address4,
      postcode: payload.customer.postcode,
      city: payload.customer.city,
      state: getStateName(payload.customer.state),
      isMalaysian: payload.customer.isMalaysian
    },
    coverage: [],
    nominee: [],
    participant: [],
    transactionOrigin: payload?.transactionOrigin || ''
  };

  // if (payload.purchaseStatus === 'A') {
  //   result.purchasestatusCode = 'IPR001';
  // }

  console.log('mapPayload____result:::', JSON.stringify(result)); // const {
  return result;
};

export const mapPayloadNewProduct = (payload) => {
  // const result = { ...payload };
  console.log('payload#####:', payload);
  payload.policyNo = Cookies.get('epfReferenceNo');
  const sessionPayload = AppStorage.getItem(ApplicationPolicyPayload);
  const customer = payload.customer;
  let memberResult;

  const product = Array.isArray(payload.product) ? payload.product : [payload.product];

  let result = {
    jti: payload.jti,
    iat: payload.exp - 1800,
    exp: payload.exp,
    timestamp: new Date().toTimeString(),
    sub: payload.sub,
    username: payload.username,
    languageCode: payload.languageCode,
    epfWithdrawalRefID: payload.epfWithdrawalRefID,
    itoOrderRefID: payload.policyNo,
    purchaseStatus: payload.purchaseStatus,
    purchasestatusCode: payload.purchaseStatusCode,
    purchaseOn: null,
    claimUpdatedDateTime: null,
    normineesUpdatedDateTime: null,
    channel: 'MBR',
    planType: payload.planType,
    product: product.map((productItem) => {
      let remainingSumAssured = 200000;
      let policyCreationStatusCode = null;

      if (payload.purchaseStatusCode === 'IPR001') {
        // member got rejected
        if (productItem.idNo === customer.idNo) {
          policyCreationStatusCode = 'PCC001';
          remainingSumAssured = 0;
        }
      } else {
        let currentSessionUser;
        if (sessionPayload) {
          // check if customer
          if (productItem.idNo === customer.idNo) {
            currentSessionUser = sessionPayload.find(
              (item) => item.payLoad.insuredPersonList.length === 1
            );
          } else {
            currentSessionUser = sessionPayload.find(
              (item) =>
                item.payLoad.insuredPersonList.find(
                  (innerItem) => innerItem.idNumber === productItem.idNo
                ) !== undefined
            );
          }
        }

        if (currentSessionUser) {
          const { underwriteMeResult, sumInsuredLevel } = currentSessionUser?.payLoad;
          if (productItem.idNo === customer.idNo) {
            memberResult = underwriteMeResult;
          }
          if (payload.purchaseStatus === 'S') {
            remainingSumAssured = remainingSumAssured - Number(sumInsuredLevel);
            policyCreationStatusCode = 'PCC003';
          } else if (underwriteMeResult === 'EXCEEDTSAR') {
            remainingSumAssured = 0;
            policyCreationStatusCode = 'PCC001';
            if (memberResult === 'REDUCESUM' && productItem.idNo !== customer.idNo) {
              policyCreationStatusCode = 'PCC002';
            }
          } else if (underwriteMeResult === 'REDUCESUM') {
            remainingSumAssured = Number(sumInsuredLevel);
            policyCreationStatusCode = 'PCC002';
          } else if (
            (underwriteMeResult === 'REFER' ||
              underwriteMeResult === 'ERROR' ||
              underwriteMeResult === 'DECLINE') &&
            productItem.idNo !== customer.idNo
          ) {
            policyCreationStatusCode = 'PCC001';
            remainingSumAssured = 0;
          }
        }
      }

      const productItemDetails = {
        idNo: productItem?.idNo,
        idType: productItem?.idType,
        amount: productItem?.premiumAmount,
        policyNo: payload.purchaseStatus === 'S' ? productItem?.policyNo : '',
        code: productItem?.code,
        basedType: 'U',
        planCode: productItem?.planCode,
        policyStatus: payload.purchaseStatus === 'S' ? 'INFORCE' : '',
        issueDateTime: null,
        termDateTime: null,
        effectiveDateTime: null,
        lineOfBusiness: productItem?.code === 'epfterm' ? 'LIFE' : 'CRIT',
        category: 'T',
        coverageAmount: productItem?.sumAssuredAmount,
        paymentMethod: 'EPF',
        paymentFrequency: 'A',
        isPolicyCreated: payload.purchaseStatus === 'S',
        policyCreationStatusCode,
        remainingSumAssured,
        unitPlan: {
          benefit: [
            {
              ...getBenefitObject(productItem),
              riderStatus: ''
            }
          ]
        }
      };
      return productItemDetails;
    }),
    customer: {
      role: payload.customer?.role,
      name: payload.customer?.name,
      idNo: payload.customer?.idNo,
      idType: payload.customer?.idType,
      mobileNo: payload.customer?.mobileNo,
      email: payload.customer?.email,
      gender: payload.customer?.gender,
      address: payload.customer?.address,
      address1: payload.customer?.address1,
      address2: payload.customer?.address2,
      address3: payload.customer?.address3,
      address4: payload.customer?.address4,
      postcode: payload.customer?.postcode,
      city: payload.customer?.city,
      state: getStateName(payload.customer?.state),
      isMalaysian: payload.customer?.isMalaysian,
      smoker: payload.customer?.smoker
    },
    coverage: [],
    nominee: [],
    participant: payload.otherParticipant ? [...payload.otherParticipant] : [],
    transactionOrigin: payload?.transactionOrigin || ''
  };

  // if (payload.purchaseStatus === 'A') {
  //   result.purchasestatusCode = 'IPR001';
  // }

  console.log('mapPayload____result:::', JSON.stringify(result)); // const {
  return result;
};

function getStateName(stateCode) {
  switch (stateCode) {
    case '01':
      return 'JOHOR DARUL TAKZIM';
    case '02':
      return 'KEDAH DARUL AMAN';
    case '03':
      return 'KELANTAN DARUL NAIM';
    case '04':
      return 'MELAKA BANDARAYA BERSEJARAH';
    case '05':
      return 'NEGERI SEMBILAN DARUL KHUSUS';
    case '06':
      return 'PAHANG DARUL MAKMUR';
    case '07':
      return 'PULAU PINANG';
    case '08':
      return 'PERAK DARUL RIDZUAN';
    case '09':
      return 'PERLIS';
    case '10':
      return 'SELANGOR DARUL EHSAN';
    case '11':
      return 'TERENGGANU DARUL IMAN';
    case '12':
      return 'SABAH';
    case '13':
      return 'SARAWAK';
    case '14':
      return 'W.PERSEKUTUAN (KUALA LUMPUR)';
    case '15':
      return 'W.PERSEKUTUAN (LABUAN)';
    case '16':
      return 'W.PERSEKUTUAN (PUTRAJAYA)';
    default:
      return stateCode;
  }
}
